export default function MediaDesktopSidebar({

    children

}){

    return(

        <aside className="media-desktop-sidebar">

            {children}

        </aside>

    );

}